import { CONSTANTS } from 'client/utils/constants';
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { GET_BULK_ORDER_SAVE } from 'Store/OrderManagement/BulkOrderSave/BulkOrderSaveType';
import OrderManagementApiService from 'Service/OrderManagement/OrderManagementApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setSaveBulkOrder } from 'Store/OrderManagement/BulkOrderSave/BulkOrderSaveAction';
import { setOrderCartData } from 'Store/Component/BulkOrder/BulkOrderAction';

function* createBulkOrderRequest(orderRequest: any): any {
    try {
        if (orderRequest?.bulkorderSave?.orderAction == CONSTANTS.ORDER_SAVE) {
            yield put(globalLoaderText("Saving Order ...."));
        } else if (orderRequest?.bulkorderSave?.orderAction == CONSTANTS.ORDER_SUBMIT) {
            yield put(globalLoaderText("Creating Order ...."));
        }

        let payloadData : IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.OrderManagement,
            endpoint: `orders/createbulkorder`,
            payload: orderRequest.bulkorderSave
          }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
            
        );

        if (response) {
            let obj : any = {}
            obj.type = orderRequest?.bulkorderSave?.orderAction
            obj.savedOrderNo = response?.orderId
            obj.isSaved = !response?.errorMessage?.length
            obj.errorMessage = response?.errorMessage
            yield put(setSaveBulkOrder(obj));
            if (response?.orderId) {
                setOrderCartData({})
            }
            yield put(globalLoaderText(""));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        let obj : any = {}
            obj.type = orderRequest?.bulkorderSave?.orderAction
            obj.savedOrderNo = 0
            obj.isSaved = false
            obj.errorMessage = ""
            yield put(setSaveBulkOrder(obj));
    }
}

function* watchBulkOrder() {
    yield takeEvery(GET_BULK_ORDER_SAVE, createBulkOrderRequest)
}

export default function* combinedSaga() {
    yield all([
        watchBulkOrder()
    ])
}
